(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name crewValidation.factory:CrewValidationRequestFactory
     *
     * @description
     *
     */
    angular
        .module('message')
        .factory('CrewValidationRequestFactory', CrewValidationRequestFactory);

    function CrewValidationRequestFactory() {

    	//----declare DTOs------
    	function ValidationRequestDTO(){
    		this.crewProfileId = null;
    		this.validationType = null;
    		this.crewType = null;
    		this.crewId = null;
        }

    	function ValidationSearchRequestDTO(){
    		this.crewBase = null;
    		this.aircraftType = null;
    		this.crewId = null;
    		this.crewType = null;
    		this.validationType = null;
    		this.validation = null;
    		this.allEntriesIncluded = false;
    		this.crewProfileid = null;
    		this.pageSize = 100000;
    		this.startPosition = 1;
    	}

    	function ValidationDTO(){
    		this.transactionId = null;
    		this.version = null;
    		this.crew = null;
    		this.crewId = null;
    		this.validation = null;
    		this.dateOfIssue = null;
    		this.neverExpire = false;
    		this.dateOfExpire = null;
    		this.dateOfWarning = null;
    		this.remarks = null;
    		this.validationType = null;
    		this.isNewJoinCrew = false;
    		this.createdDateTime = null;
    		this.base = null;
    		this.acType = null;
    		this.crewType = null;
    		this.validationNo = null;
    		this.warningBefore = 0;
    		this.validationCountries = [];
    		this.ignorOverlap = false;
    		this.warningDatePickerOption = { maxDate:null};
    	}

    	function SaveValidationRequest(){
    		this.ignorOverlap = false;
			this.transactionId = null;
			this.version = null;
			this.crewProfileId = null;
			this.validationId = null;
			this.modelNo = null;
			this.dateOfIssue = null;
			this.neverExpire = null;
			this.dateOfExpire = null;
			this.dateOfWarning = null;
			this.remarks = null;
			this.validationNumber = null;
			this.newJoinedCrew = false;
			this.createdDateTime = null;
			this.visaValidationCountries = [];
    	}

    	function DeleteValidationRequest(){
    		this.transactionId = null;
    		this.version=null;
    	}

    	function ACTypeByValidationRequest(){
    		this.validationId = null;
    	}

        //----Define Function --------
    	//setter and setters of validation request
    	function GetFormattedValidationRequest(searchParam){
    		var valReq = new ValidationRequestDTO();
    		if(!!searchParam.crew && !!searchParam.crew.crewProfileId){
    			valReq.crewProfileId = searchParam.crew.crewProfileId;
			}
			if(!!searchParam.validationType && !!searchParam.validationType.code){
				valReq.validationType= searchParam.validationType.code;
			}
			if(!!searchParam.crewType && !!searchParam.crewType.crewTypeCode){
				valReq.crewType = searchParam.crewType.crewTypeCode;
			}
			if(!!searchParam.crewId){
				valReq.crewId = searchParam.crewId;
			}
			return valReq;
    	}

    	function GetValidationReq(){
    		return new ValidationRequestDTO();
    	}

    	//getter and setters of validation search request
    	function GetValidationSearchRequest(){
    		return new ValidationSearchRequestDTO();
    	}

    	function GetFormattedValidationSearchRequest(param){
    		var validationSearchReq = new ValidationSearchRequestDTO();
    		if(!!param.aircraftType){
    			validationSearchReq.aircraftType = param.aircraftType.modelNumber;
			}
			if(!!param.crew){
				validationSearchReq.crewProfileid= param.crew.crewProfileId;
			}
			if(!!param.crewBase){
				validationSearchReq.crewBase = param.crewBase.airPortCode;
			}
			if(!!param.crewId){
				validationSearchReq.crewId = param.crewId;
			}
			if(!!param.crewType){
				validationSearchReq.crewType = param.crewType.crewTypeCode;
			}
			if(!!param.includeAll){
				validationSearchReq.allEntriesIncluded= param.includeAll;
			}
			if(!!param.validation){
				validationSearchReq.validation = param.validation.id;
			}
			if(!!param.validationType){
				validationSearchReq.validationType = param.validationType.code;
			}
			return validationSearchReq;

    	}

    	//getter and setters of validation
    	function GetValidation(){
    		return new ValidationDTO();
    	}

    	function GetFormattedValidation(param){
    		var validationDTO = new ValidationDTO();
    		validationDTO.transactionId = param.crewExpiryId;
    		validationDTO.version = param.version;
    		validationDTO.crew = param.crewName;
    		validationDTO.crewId = param.crewId;
    		validationDTO.validation = param.validation;
    		validationDTO.dateOfIssue = param.dateOfIssue;
    		validationDTO.neverExpire = param.neverExpire=='Y' ? true : false;
    		if(!validationDTO.neverExpire){
    			if(!!param.dateOfExpiry){
        			validationDTO.dateOfExpire = param.dateOfExpiry;
        			validationDTO.warningDatePickerOption.maxDate = new Date(validationDTO.dateOfExpire);
        		}
        		if(!!param.warningDate){
        			validationDTO.dateOfWarning = param.warningDate;
        		}else{
        			validationDTO.dateOfWarning = validationDTO.dateOfExpire;
        		}
        		if(!!validationDTO.dateOfWarning && !!validationDTO.dateOfExpire){
        			var expire = moment(validationDTO.dateOfExpire,'DD/MM/YYYY');
    				var warning = moment(validationDTO.dateOfWarning,'DD/MM/YYYY');
    				var diffDays = expire.diff(warning, 'days');
    				validationDTO.warningBefore = diffDays;
        		}
    		}else{
    			validationDTO.dateOfExpire = null;
    			validationDTO.dateOfWarning = null;
    			validationDTO.warningBefore = null;
    		}
    		validationDTO.remarks = param.remrks;
    		validationDTO.validationType = param.validationTypeCode;
    		validationDTO.isNewJoinCrew = param.isNewJoinCrew;
    		validationDTO.createdDateTime = param.createdDate;
    		validationDTO.base = param.crewBase;
    		validationDTO.acType = param.aircraftType;
    		validationDTO.validationCountries = [];
    		validationDTO.crewType = param.crewType;
    		validationDTO.validationNo = param.validationNumber;

    		return validationDTO;
    	}

    	//getter and setters of validationSaveRequest
    	function GetSaveValidationRequest(){
    		return new SaveValidationRequest();
    	}

    	function GetFormattedSaveValidationRequest(param){
    		var valSaveReq = new SaveValidationRequest();
    		valSaveReq.ignorOverlap = param.ignorOverlap;
    		valSaveReq.transactionId = param.transactionId;
    		valSaveReq.version = param.version;
    		if(!!param.crew && !!param.crew.crewProfileId){
    			valSaveReq.crewProfileId = param.crew.crewProfileId;
    		}
    		if(!!param.validation && !!param.validation.id){
    			valSaveReq.validationId = param.validation.id;
    		}
    		if(!!param.acType && !!param.acType.modelNumber){
    			valSaveReq.modelNo = param.acType.modelNumber;
    		}

        if(valSaveReq.modelNo === null && param.validation.modelNumber !== null){
          valSaveReq.modelNo = param.validation.modelNumber;

        }

    		valSaveReq.dateOfIssue = param.dateOfIssue;
    		valSaveReq.neverExpire = param.neverExpire;
    		valSaveReq.dateOfExpire = param.dateOfExpire;
    		valSaveReq.dateOfWarning = param.dateOfWarning;
    		valSaveReq.remarks = param.remarks;
    		valSaveReq.validationNumber = param.validationNo;
    		valSaveReq.newJoinedCrew = param.isNewJoinCrew=='Y'?true:false;
    		valSaveReq.createdDateTime = param.createdDateTime;
    		if(!!param.validationCountries && param.validationCountries.length>0){
    			for(var country=0; country < param.validationCountries.length;country++ ){
    				valSaveReq.visaValidationCountries.push(param.validationCountries[country].code);
    			}
    		}
    		return valSaveReq;
    	}

    	//getter and setters of delete validation request
    	function GetDeleteValidationRequest(){
    		return new DeleteValidationRequest();
    	}

    	function GetFormattedDeleteValidationRequest(crewValidation){
    		var deleteValidaitonReq = new DeleteValidationRequest();
    		deleteValidaitonReq.transactionId = crewValidation.transactionId;
    		deleteValidaitonReq.version = crewValidation.version;
    		return deleteValidaitonReq;
    	}

    	//getter and setters of AC Type By Validation Request
        function GetACTypeByValidationRequest(){
        	var req = new ACTypeByValidationRequest();
        	return req;
        }

        function GetFormattedACTypeByValidationRequest(selectedValidation){
        	var req = new ACTypeByValidationRequest();
        	if(!!selectedValidation.validation){
        		req.validationId = parseInt(selectedValidation.validation.id);
        	}
        	return req;
        }

        //map services to return
        return {
        	getFormattedValidationRequest : GetFormattedValidationRequest,
        	getValidationReq : GetValidationReq,
        	getValidationSearchRequest :GetValidationSearchRequest,
        	getFormattedValidationSearchRequest :GetFormattedValidationSearchRequest,
        	getValidation : GetValidation,
        	getFormattedValidation : GetFormattedValidation,
        	getSaveValidationRequest : GetSaveValidationRequest,
        	getFormattedSaveValidationRequest : GetFormattedSaveValidationRequest,
        	getDeleteValidationRequest : GetDeleteValidationRequest,
        	getFormattedDeleteValidationRequest : GetFormattedDeleteValidationRequest,
        	getACTypeByValidationRequest : GetACTypeByValidationRequest,
        	getFormattedACTypeByValidationRequest : GetFormattedACTypeByValidationRequest
        }

    }
})();
